import React from "react";
import "./CandidatesCard.css";
import { select } from "framer-motion/client";

const CandidatesCard = ({
  FullName,
  Email,
  LinkUrl,
  Id,
  onHandleClick,
  selected,
  creationDate,
}) => {
  return (
    <div
      className={`card-container ${selected && "selected"}`}
      key={Id}
      onClick={() => onHandleClick({ Email, FullName, LinkUrl, Id })}
    >
      <p>{FullName}</p>
      <p>{Email}</p>
      <p>{creationDate}</p>
    </div>
  );
};

export default CandidatesCard;
